import React from "react";
import { PrestationsTemplate } from "../../components/templates";

function Prestations() {
  return <PrestationsTemplate />;
}

export default Prestations;
